import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {ActionResult, CompetitorCount, Waypoint} from "@model";
import { Observable, map } from "rxjs";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class WaypointService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  updateWaypoint(waypoint: Waypoint, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + (waypoint.id ? "/api/waypoint/update" : "/api/waypoint/add"), waypoint)
      .subscribe(actionResult => actionResult.resultCode !== -1 ? onSuccess() : onError());
  }

  deleteWaypoint(waypointId: number, raceId: number|undefined, onSuccess: () => void, onError: () => void): void {
    this.http.delete<ActionResult<boolean>>(this.environmentService.getApiUrl() + `/api/waypoint/delete?waypointId=${waypointId}` + (raceId ? `&raceId=${raceId}` : ''), {})
      .subscribe(actionResult => actionResult.resultCode !== -1 ? onSuccess() : onError(), () => onError());
  }

  findWaypoints(raceId?: number): Observable<Waypoint[]> {
    return this.http.get<ActionResult<Waypoint[]>>(this.environmentService.getApiUrl() + `/api/public/waypoint/race/fetch?raceId=${raceId}`).pipe(
      map(actionResult => actionResult.resultCode !== -1 ? (actionResult.result ?? []) : [])
    );
  }

  findEventWaypoints(eventId?: number): Observable<Waypoint[]> {
    return this.http.get<ActionResult<Waypoint[]>>(this.environmentService.getApiUrl() + `/api/waypoint/fetchbyeventid?eventId=${eventId}`).pipe(
      map(actionResult => actionResult.resultCode !== -1 ? (actionResult.result ?? []) : [])
    );
  }

  findMeasurementWaypoints(eventId: number): Observable<Waypoint[]> {
    return this.http.get<ActionResult<Waypoint[]>>(this.environmentService.getApiUrl() + `/api/waypoint/measurement/fetch?eventId=${eventId}`).pipe(
      map(actionResult => actionResult.resultCode !== -1 ? (this.removeDuplicateWaypoints(actionResult.result ?? [])) : [])
    );
  }

  findMeasurementWaypoint(eventId: number, waypointId: number): Observable<Waypoint | undefined> {
    return this.http.get<ActionResult<Waypoint>>(this.environmentService.getApiUrl() + `/api/waypoint/fetchbywaypointid?eventId=${eventId}&waypointId=${waypointId}`).pipe(
      map(actionResult => actionResult.result)
    );
  }

  findMeasurementWaypointCount(eventId: number, waypointId: number): Observable<CompetitorCount | undefined> {
    return this.http.get<ActionResult<CompetitorCount>>(this.environmentService.getApiUrl() + `/api/waypoint/measurement/count?eventId=${eventId}&waypointId=${waypointId}`).pipe(
      map(actionResult => actionResult.result)
    );
  }

  private removeDuplicateWaypoints(waypoints: Waypoint[]): Waypoint[] {
    const uniqueWaypointsMap = new Map<number, Waypoint>();
    waypoints.forEach(waypoint => {
      if (!uniqueWaypointsMap.has(waypoint.id!)) {
        uniqueWaypointsMap.set(waypoint.id!, waypoint);
      }
    });
    return Array.from(uniqueWaypointsMap.values());
  }
}
